module.exports = __webpack_public_path__ + "static/img/mark2-BLLBmBgP.6cb1b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark2-BLLBmBgP.png
// module id = H1qM
// module chunks = 16